import WithRender from "../../templates/layouts/layoutUploadConfiguration.html";

export default WithRender({});
